import Api from 'App/api'

//Attention: This is a duplicate in ledger module as well. Keep only one
export const getLedger = Api.get({
  controller: 'ledger',
  action: 'getLedger',
})

export const getAvailablePaymentTypes = Api.get({
  controller: 'payments',
  action: 'getAvailablePaymentTypes',
})

// Auto payments
export const getScheduledPaymentSettings = Api.get({
  controller: 'scheduled_payments',
  action: 'getSettings',
})

export const postScheduledPayment = Api.post({
  controller: 'scheduled_payments',
  action: 'save',
})

export const approveScheduledPayment = Api.post({
  controller: 'scheduled_payments',
  action: 'approveSplit',
})

export const getScheduledPayments = Api.get({
  controller: 'scheduled_payments',
  action: 'listWithSettings',
})

export const getScheduledPaymentList = Api.get({
  controller: 'scheduled_payments',
  action: 'list',
})

export const deleteScheduledPayment = Api.post({
  controller: 'scheduled_payments',
  action: 'delete',
})

export const getAutoPaymentStatus = Api.get({
  controller: 'scheduled_payments',
  action: 'getAutoPaymentStatus'
})

// Payment Accounts
export const savePaymentMethod = Api.post({
  controller: 'payment_accounts',
  action: 'add',
})

export const updatePaymentAccount = Api.post({
  controller: 'payment_accounts',
  action: 'update',
})

export const getPaymentMethods = Api.get({
  controller: 'payment_accounts',
  action: 'list',
})

export const getPaymentMethodWithSettings = Api.get({
  controller: 'payment_accounts',
  action: 'listWithSettings',
})

export const deletePaymentAccount = Api.post({
  controller: 'payment_accounts',
  action: 'delete',
})

export const getPaymentAccounts = Api.get({
  controller: 'payment_accounts',
  action: 'list',
})

export const authCapturePayment = Api.post({
  controller: 'payments',
  action: 'authCapture',
})

export const createInvoicePayment = Api.post({
  controller: 'stripe_invoice',
  action: 'add_payment',
})

export const authBulkCapturePayment = Api.postWithToken({
  controller: 'payments',
  action: 'authCapture',
  useCustomToken: true,
})

export const getPaymentSettings = Api.get({
  controller: 'payments',
  action: 'getSettings',
})

export const cancelPayment = Api.post({
  controller: 'payments',
  action: 'cancel',
})

// Bank name from routing number
export const getBankName = Api.get({
  controller: 'payments',
  action: 'getBankName',
})

// Money Gram
export const getMoneyGram = Api.get({
  controller: 'moneygram',
  action: 'get',
})

export const getMoneyGramInstructions = Api.get({
  controller: 'moneygram',
  action: 'getInstructions',
})

export const addMoneyGramAccount = Api.post({
  controller: 'moneygram',
  action: 'create',
})

export const addBulkPaymentMoneyGramAccount = Api.postWithToken({
  controller: 'moneygram',
  action: 'create',
  useCustomToken: true,
})

// Re-payments
export const getRepaymentHistoryData = Api.get({
  controller: 'repayments',
  action: 'history',
})

export const getRepaymentList = Api.get({
  controller: 'repayments',
  action: 'list',
})

export const getRepaymentDetailsData = Api.get({
  controller: 'repayments',
  action: 'listDetails',
})

// Refund Module
export const getRefundAccountWithSettings = Api.get({
  controller: 'refund_accounts',
  action: 'listWithSettings',
})

export const deleteRefundAccount = Api.post({
  controller: 'refund_accounts',
  action: 'delete',
})

export const saveRefundAccount = Api.post({
  controller: 'refund_accounts',
  action: 'add',
})

export const saveCustomerPlaidItem = Api.post({
  controller: 'customer_plaid_items',
  action: 'save',
})

export const getPlaidInactiveAccounts = Api.get({
  controller: 'customer_plaid_items',
  action: 'getInactiveAccounts',
})

export const createPublicToken = Api.post({
  controller: 'customer_plaid_items',
  action: 'createPublicToken',
})

export const createLinkToken = Api.post({
  controller: 'customer_plaid_items',
  action: 'linkToken',
})

export const getPlaidLinkedAccount = Api.post({
  controller: 'customer_plaid_items',
  action: 'getPlaidLinkedAccount',
})

export const createLinkTokenForPaymentInitiation = Api.post({
  controller: 'customer_plaid_items',
  action: 'linkToken',
})

export const createPaymentIntiation = Api.post({
  controller: 'payment_initiation',
  action: 'create',
})

export const createRelinkToken = Api.post({
  controller: 'customer_plaid_items',
  action: 'relinkToken',
})

export const getMoneygramSettings = Api.get({
  controller: 'moneygram',
  action: 'getWithSettings',
})

export const postValidatePayment = Api.postWithToken({
  controller: 'payments',
  action: 'validatePayment',
  useCustomToken: true,
})

export const refreshPlaidPaymentAccounts = Api.post({
  controller: 'payment_accounts',
  action: 'refresh',
})

export const postValidateIBTPayment = Api.post({
  controller: 'payments',
  action: 'validatePayment',
})

export const cancelPaymentIntiation = Api.post({
  controller: 'payment_initiation',
  action: 'cancel',
})

export const getPaymentDetails = Api.post({
  controller: 'payments',
  action: 'getPaymentDetails',
})

export const createUnionPayment = Api.post({
  controller: 'union_pay',
  action: 'create',
})

export const createStripePayment = Api.post({
  controller: 'stripe_payment',
  action: 'add_payment',
})

export const updatePaymentOperation = Api.post({
  controller: 'payments',
  action: 'paymentOperation',
})

export const getLastPaymentDetails = Api.post({
  controller: 'payments',
  action: 'getLastPaymentDetails',
})

export const getLast48HoursPaymentDetails = Api.post({
  controller: 'payments',
  action: 'getLast48HoursPaymentDetails',
})

export const postWorldPay3dsLogs = Api.post({
  controller: 'payment_logs',
  action: 'insert_worldpay_3ds_logs',
})

export const validateApplePayMerchant = Api.post({
  controller: 'wallet_payments',
  action: 'validate_applepay_merchant',
})

export const processWalletPayment = Api.post({
  controller: 'wallet_payments',
  action: 'process_wallet_payment',
})

export const postValidateApplePayPayment = Api.post({
  controller: 'validate_wallet_payments',
  action: 'apple_pay',
})

export const createSetupIntent = Api.post({
  controller: 'payment_accounts',
  action: 'create_setup_intent',
})

export const fxConversion = Api.post({
  controller: 'fx_conversion',
  action: 'get_conversion_rates',
})

export const createTransfermatePayment = Api.post({
  controller: 'tm_payment',
  action: 'create',
})

// API for validate passcode
export const validatePassCode = Api.post({ 
  controller: 'passcode',
  action: 'validate',
});
// API for send new passcode
export const sentNewPassCode = Api.post({ 
  controller: 'passcode',
  action: 'sendNew',
});

// API for get authorized transfermate payments
export const getAuthorizedTransfermatePayments = Api.get({
  controller: 'tm_payment',
  action: 'get_authorized_transfermate_payments',
});

// API to get available payment method count
export const getAvailablePaymentMethodCount = Api.get({
  controller: 'payment_accounts',
  action: 'availablePaymentMethod'
});



